<template>

        <div :id="problem.id" :class="'accordion-section'+ (problem.open?' active':'')" v-if="problem.data">
          <div class="accordion-header" @click="problem.open = !problem.open">
            <div class="accordion-title">
              <i :class="'bi '+ problem.ico"></i> {{ problem.name }}
              <span :class="'accordion-badge ' + (problem.count <= 0?'success':problem.count<2?'info':problem.count<20?'warning':'critical')">{{ problem.count }} ошибок</span>
            </div>
            <div class="accordion-icon">▼</div>
          </div>
          <div :class="'accordion-content'+ (problem.open?' active':'')">
            <!-- Last 24h stats -->
            <h3>📈 За последние 24 часа</h3>
            <div class="metric-group">
              <div class="metric-item">
                <div class="metric-value">{{ problem.data.last_24h_stats.total_created }}</div>
                <div>Всего создано</div>
              </div>
              <div class="metric-item">
                <div class="metric-value" style="color: #27ae60;">{{ problem.data.last_24h_stats.collected }}</div>
                <div>✅ Собрано</div>
              </div>
              <div class="metric-item">
                <div class="metric-value" style="color: #e74c3c;">{{ problem.data.last_24h_stats.with_errors }}</div>
                <div>❌ С ошибками</div>
              </div>
            </div>

            <!-- Errors by Project -->
            <h3>📊 Ошибки по проектам</h3>
            <table class="data-table">
              <thead>
              <tr>
                <th>Проект</th>
                <th>Ошибок</th>
                <th>%</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="problem.data.errors_by_project.length">
              <tr v-for="project in problem.data.errors_by_project">
                <td><strong>{{ project.link__project__name }}</strong>
                  <strong>(ID: {{ project.link__project__id }})</strong></td>
                <td><strong>{{ project.error_count }}</strong></td>
                <td>
                  <div class="progress-bar">
                    <div class="progress-fill danger"
                         :style="{width: $widthratio(project.error_count, problem.count) + '%'}"></div>
                  </div>
                  <small>{{$widthratio(project.error_count, problem.count) + '%'}}</small>
                </td>
              </tr>
                </template>
              <tr v-else>
                <td colspan="3">Нет ошибок</td>
              </tr>
              </tbody>
            </table>

            <!-- Errors by Resource -->
            <h3>🔗 Ошибки по ресурсам</h3>
            <table class="data-table">
              <thead>
              <tr>
                <th>Ресурс</th>
                <th>Ошибок</th>
                <th>%</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="problem.data.errors_by_resource.length">
              <tr v-for="resource in problem.data.errors_by_resource">
                <td><strong>{{ resource.link__resource__name }}</strong>
                  <strong>(ID: {{ resource.link__resource__id }})</strong></td>
                <td><strong>{{ resource.error_count }}</strong></td>
                <td>
                  <div class="progress-bar">
                    <div class="progress-fill danger"
                         :style="{width: $widthratio(resource.error_count, problem.count) + '%'}"></div>
                  </div>
                  <small>{{ $widthratio(resource.error_count, problem.count) + '%' }}</small>
                </td>
              </tr>
              </template>
              <tr v-else>
                <td colspan="3">Нет ошибок</td>
              </tr>
              </tbody>
            </table>

            <!-- Detailed Errors -->
            <h3>🔍 Детальная статистика ошибок (Топ-20)</h3>
            <table class="data-table">
              <thead>
              <tr>
                <th>Проект</th>
                <th>Ресурс</th>
                <th>Тип ошибки</th>
                <th>Кол-во</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="problem.data.errors_detailed.length">
              <tr v-for="error in problem.data.errors_detailed">
                <td><strong>{{ error.link__project__name }}</strong></td>
                <td><strong>{{ error.link__resource__name }}</strong></td>
                <td><code>{{ error.error }}</code></td>
                <td><strong>{{ error.count }}</strong></td>
              </tr>
              </template>
              <tr v-else>
                <td colspan="4">Нет детальных данных</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>


</template>

<script>

export default {
  name: 'ParserInfo',
  data() {
    return {}
  },
  props: {
    problem: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">

</style>